export const PAYROLL_SALARY_LOADING = "PAYROLL_SALARY_LOADING";
export const PAYROLL_SALARY_RESET = "PAYROLL_SALARY_RESET";
export const GET_PAYROLL_SALARY = "GET_PAYROLL_SALARY";
export const GET_PAYROLL_SALARY_SUCCESS = "GET_PAYROLL_SALARY_SUCCESS";
export const GET_PAYROLL_SALARY_FAIL = "GET_PAYROLL_SALARY_FAIL";
export const DELETE_PAYROLL_SALARY = "DELETE_PAYROLL_SALARY"
export const DELETE_PAYROLL_SALARY_SUCCESS = "DELETE_PAYROLL_SALARY_SUCCESS"
export const DELETE_PAYROLL_SALARY_FAIL = "DELETE_PAYROLL_SALARY_FAIL"
export const UPDATE_PAYROLL_SALARY = "UPDATE_PAYROLL_SALARY"
export const UPDATE_PAYROLL_SALARY_SUCCESS = "UPDATE_PAYROLL_SALARY_SUCCESS"
export const UPDATE_PAYROLL_SALARY_FAIL = "UPDATE_PAYROLL_SALARY_FAIL"
export const ADD_NEW_PAYROLL_SALARY = "ADD_NEW_PAYROLL_SALARY"
export const ADD_PAYROLL_SALARY_SUCCESS = "ADD_PAYROLL_SALARY_SUCCESS"
export const ADD_PAYROLL_SALARY_FAIL = "ADD_PAYROLL_SALARY_FAIL"